/**
 * Stores build information. The string literals are replaces at compile time by `set_version.js`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2023-12-13",
    versionChannel: "nightly",
    buildDate: "2023-12-13T00:14:47.719Z",
    commitHash: "282f712f54c3ce017e877a116b59b8df14800745",
};
